// RUSSIAN (ru) for the console's agents tab (spec 15 §4 S23; D-645). Same
// keys as admin-agents.i18n.ts; the terms follow admin.ru.ts (клиент for
// tenant) and the office's agents.ru.ts (агент, профиль модели).

import type { Translated } from "../../i18n-shape.js";
import type { adminAgentsEn } from "./admin-agents.i18n.js";

export const adminAgentsRu: Translated<typeof adminAgentsEn> = {
  agentModels: {
    tab: "Агенты",
    title: "Агенты",
    lead: "Каждый агент и профиль модели, на котором он работает.",
    leadRecorded: "Записанный профиль воспроизводит сохранённые ответы и не обращается к модели.",
    leadLive:
      "Рабочий профиль обращается к модели в Amazon Bedrock, и за него платят по числу токенов.",
    sandboxNote:
      "Ваша область песочницы охватывает только клиентов песочницы, поэтому агенты этого клиента доступны вам только для чтения.",
    viewerNote:
      "Профиль модели агента переключают администраторы платформы. Здесь он доступен вам для чтения.",
    loading: "Загрузка агентов…",
    loadFailed: "Не удалось загрузить агентов клиента.",
    emptyTitle: "Агентов пока нет",
    emptyBody:
      "Агенты создаются в течение минуты после того, как клиент стал активным, если настроен профиль модели.",
    colAgent: "Агент",
    colStatus: "Статус",
    colProfile: "Профиль модели",
    colBudget: "Дневной бюджет токенов",
    colAction: "Действие",
    status: {
      enabled: "Включён",
      paused: "На паузе",
      disabled: "Выключен",
    },
    adapter: {
      bedrock: "Рабочая модель (Amazon Bedrock)",
      recorded: "Записанные ответы, без модели",
      other: "Здесь не предлагается",
    },
    availability: {
      ok: "Модель найдена",
      unchecked: "Ещё не проверен",
      unavailable: "Недоступен: {{reason}}",
    },
    profilesTitle: "Профили в этой среде",
    defaultProfile: "Новые агенты начинают с профиля: {{name}}",
    noDefault: "Профиль не настроен, поэтому здесь не может работать ни один агент.",
    noBedrockTitle: "В этой среде нет рабочей модели",
    noBedrockBody:
      "У её серверов нет доступа к Bedrock, поэтому агенты здесь могут только воспроизводить записанные ответы.",
    noBedrockFix:
      "Для рабочей подготовки черновиков нужна среда, в настройках агентов которой указан профиль Bedrock.",
    price: "Вход: {{input}} за миллион токенов · выход: {{output}} за миллион токенов",
    noPrice: "Бесплатно",
    change: "Изменить",
    noTargets: "Другой профиль выбрать нельзя.",
    dialogTitle: "Изменить профиль модели",
    dialogLead: "Сейчас {{agent}} работает на профиле {{current}}.",
    choose: "Новый профиль",
    costTitle: "Это стоит денег",
    costRuns:
      "На профиле {{profile}} каждый запуск обращается к модели и оплачивается по числу токенов.",
    costBudget:
      "Дневной бюджет токенов этого агента: {{budget}}. Полный день стоит около {{ceiling}} по цене выходных токенов.",
    costAccount: "Расходы учитываются в месячном бюджете Bedrock этого аккаунта.",
    freeRuns:
      "На профиле {{profile}} агент воспроизводит записанные ответы, не обращается к модели и ничего не стоит.",
    freeGap: "Сообщение, для которого нет записи, агент не обработает.",
    effect: "Изменение действует для каждого запуска, который ещё не обращался к модели.",
    cancel: "Отмена",
    confirm: "Переключить на {{profile}}",
    saving: "Переключение…",
    switched: "Теперь {{agent}} работает на профиле {{profile}}.",
    refusal: {
      conflict: "Кто-то изменил этого агента раньше вас. Показан его текущий профиль.",
      noBedrock: "В этой среде нет профиля Bedrock, поэтому рабочая модель здесь недоступна.",
      unknownProfile: "В этой среде нет такого профиля. Ничего не изменено.",
      notOffered: "Этот профиль служит для тестов, и консоль его не устанавливает.",
      unavailable: "Модель этого профиля сейчас недоступна. Ничего не изменено.",
      forbidden: "Ваша роль не позволяет изменить этого агента.",
      gone: "Этого агента больше нет. Список загружается заново.",
      failed: "Изменение не прошло. Попробуйте ещё раз.",
    },
  },
};
